export enum SearchType {
  efan = 'efan',
  domainName = 'domainName',
  epmLocationId = 'epmLocationId',
}
